//Not even a wannabe Router, just something to handle 2-3 routes and get started

import Events from '../../_utils/events.js';

class Router extends Events {

	constructor(root) {
		super();

		this.checkPushStateSupport();

		this.root = this.clean(root || '') || '/';
		this.isAbsoluteRoot = this.root === '/';
		this.states = {};
		this.currentState = '';
		this.currentURL = '';

		window.onpopstate = () => {
			this.resolvePopState();
		};

		return this;
	}


	state(stateName, stateConfig) {
		stateConfig = stateConfig || {};

		if (stateConfig.path === '/' || !stateConfig.path) {
			this.rootState = {
				stateName: stateName,
				stateConfig: stateConfig,
				routeParams: []
			};
		} else {
			stateConfig.path = this.clean(stateConfig.path);
			//Get all ':' route params from path
			stateConfig.routeParams = stateConfig.path.match(/(\:[^/?&]+)/g) || [];
			stateConfig.matchRegexStr = stateConfig.path
				//Try to escape regex special chars
				.replace('/', '\\/').replace('?', '\\?')
				.replace('&', '\\&').replace('!', '\\!')
				.replace('@', '\\@').replace('$', '\\$')
				.replace('%', '\\%').replace('*', '\\*')
				.replace('.', '\\.').replace('+', '\\+')
				//Create capturing groups for each routeParam
				.replace(/(\:[^/?&]+)/g, '([^/?&]+)');

			this.states[stateName] = stateConfig;
		}

		return this;
	}

	navigate(stateName, ...args) {
		let 
		state = this.states[stateName] || 
			(this.rootState.stateName === stateName ? this.rootState.stateConfig : null),
		newURL;

		if (!state) {
			throw new Error('Undefined state');
		}

		newURL = this.clean(this.root + state.path);

		state.routeParams.forEach((routeParam, index) => {
			newURL = newURL.replace(routeParam, args[index]);
		});

		if (this.currentURL === newURL) {
			return;
		}

		this.trigger('before:url:change');
		history.pushState({}, '', newURL);
		this.currentURL = newURL;
		this.trigger('url:change');

		this.trigger('before:state:change');
		state.resolve.apply(this, args);
		this.currentState = state;
		this.trigger('state:change');

		return this;
	}

	resolvePopState() {
		let 
		url = this.clean('/' + window.location.pathname.replace(this.root, ''));
		
		if (!url || url === '/') {
			if (this.rootState && this.rootState.stateConfig.resolve) {
				this.rootState.stateConfig.resolve();
			}
		} else {
			let stateMatch = this.getMatchState(url);

			if (stateMatch) {
				stateMatch.state.resolve.apply(this, stateMatch.args);
			}
		}

		this.currentURL = window.location.pathname + window.location.search;
	}

	getMatchState(urlPath) {
		//TODO: break the forEach when match state found?
		let
		matchState;

		Object.keys(this.states).forEach(key => {
			let 
			state = this.states[key],
			routeArgs;

			routeArgs = (new RegExp(state.matchRegexStr, 'g').exec(urlPath) || []);
			routeArgs.splice(0,1); //Remove first element - full match

			if (routeArgs.length > 0) {
				matchState = {
					state: state,
					args: routeArgs
				};
			}
		});

		return matchState;
	}

	checkPushStateSupport() {
		if (
			!window.history ||
			!window.history.pushState
		) {
			throw new Error('This router only works in pushState-supported browsers');
		}

		return true;
	}

	clean(s) {
		return s.replace(/\/+$/, '').replace(/^\/+/, '/');
	}

}

export default Router;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_components/router/router.js